module.exports = __webpack_public_path__ + "img/92160.5df9d7e0.svg";